// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ReactDOM from 'react-dom';
interface DisclosureProps {
    containerClass?: string;
    btnClass?: string;
    expandFunct: () => void;
    collapseFunct: () => void;
}

const DisclosureWidget = (props: DisclosureProps) => {
    let btnClass: string = props.btnClass ? props.btnClass : "";

    return (
        <div className={props.containerClass}>
            <i className={`fa fa-minus-square ${btnClass}`} aria-hidden="true" onClick={props.collapseFunct} title={InovxLoader.t("common:message.collapse") }></i>
            <i className={`fa fa-plus-square ${btnClass}`} aria-hidden="true" onClick={props.expandFunct} title={InovxLoader.t("common:message.expand") }></i>
        </div>
    )
}

export default DisclosureWidget;